import * as React from 'react';
import {connect} from 'react-redux';
import {AxiosRequestConfig, AxiosResponse} from "axios";
import store from "../../config/store";
import {ISpinner, STATUS, TYPE} from '../../reducers/actionSpinner';
import Modal from "react-responsive-modal";
import 'react-circular-progressbar/dist/styles.css';
import RadialSeparators from "./RadialSeparators";
import {buildStyles, CircularProgressbarWithChildren} from "react-circular-progressbar";
import {deleteSpinner, setSpinner, updateSpinner,} from "../../actions/actionSpinnerActions";
import Axios from "../../config/Axios";
import Utils from "../../Utils";

const hash = require('object-hash');
const Loader = require('react-loader-spinner').default;

interface Props {
    isOpen: boolean;
    loadingMapHash: string;
    loadingMap: Map<string, ISpinner>;

    resetState(): void;
}

interface State {
    spinner: ISpinner | null;
}

interface ISpinnerConfig {
    key: string,
    showOnSuccess?: boolean,
    showOnError?: boolean,
    onSuccessMessage?: string,
    onErrorMessage?: string,
    excludeSpinner?: boolean,
    useNewAxiosInstance?: boolean
}

class ActionSpinner extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            spinner: props.loadingMap.values().next().value
        }
    }

    onClose = () => {
        if (this.state.spinner) {
            store.dispatch(deleteSpinner(this.state.spinner.key));
            this.setState({spinner: null});
        }
    };

    getFasClass(): string {
        if (this.state.spinner) {
            switch (this.state.spinner.status) {
                case STATUS.ERROR:
                    return "fas fa-frown fa-3x";
                case STATUS.SUCCESS:
                    return "fas fa-smile fa-3x";
                case STATUS.WARNING:
                    return "fas fa-meh fa-3x";
            }
        }
        return ""
    }

    UNSAFE_componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
        this.setState({spinner: nextProps.loadingMap.values().next().value})
    }

    getProgressInfo = (): React.ReactNode => {
        if (this.state.spinner) {
            if (this.state.spinner.notification.failed) {
                return (
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <label
                                style={{color: "white"}}>Total: {this.state.spinner.notification.total}</label>
                        </div>
                        <div className={"col-4"}>
                            <label style={{color: "white"}}>Failed: {this.state.spinner.notification.failed}</label>
                        </div>
                        <div className={"col-4"}>
                            <label style={{color: "white"}}>Done: {this.state.spinner.notification.done}</label>
                        </div>
                    </div>
                )
            }
            return (
                <div className={"row"}>
                    <div className={"col-6"}>
                        <label style={{color: "white"}}>Total: {this.state.spinner.notification.total}</label>
                    </div>
                    <div className={"col-6"}>
                        <label style={{color: "white"}}>Done: {this.state.spinner.notification.done}</label>
                    </div>
                </div>
            )
        }
        return null;
    };

    getContent = (): React.ReactNode => {
        if (this.state.spinner) {
            switch (this.state.spinner.type) {
                case TYPE.INFINITE_LOADING:
                    return (
                        <div style={{width: 100, margin: 'auto', outline: 'none'}}>
                            <Loader
                                type="Oval"
                                color={"#00BFFF"}
                                height={100}
                                width={100}
                            />
                        </div>
                    );
                case TYPE.PROGRESS:
                    return (
                        <div style={{margin: 'auto'}}>
                            <div style={{textAlign: "center"}} className={"container-fluid"}>
                                <div className={"row"}>
                                    <div className={"col-12"}>
                                        <label
                                            style={{color: "white"}}>{this.state.spinner.notification.message}</label>
                                    </div>
                                </div>
                            </div>
                            <div style={{width: 150, margin: 'auto'}}>
                                <CircularProgressbarWithChildren
                                    value={this.state.spinner.notification.complete}
                                    text={isNaN(this.state.spinner.notification.complete / 100) ? " " :
                                        (Number(this.state.spinner.notification.complete / 100).toLocaleString(undefined, {
                                            style: "percent",
                                            maximumFractionDigits: 0
                                        }))}
                                    styles={buildStyles({
                                        strokeLinecap: "butt",
                                        textSize: '30px',
                                        pathTransitionDuration: 0,
                                        pathColor: `rgb(${this.state.spinner.notification.complete * 2.55}, 150 ,0)`,
                                        textColor: "white",
                                        trailColor: '#d6d6d6',
                                        backgroundColor: '#3e98c7',
                                    })}
                                    strokeWidth={10}
                                >
                                    <RadialSeparators
                                        count={20}
                                        style={{
                                            background: "#fff",
                                            width: "2px",
                                            height: `${10}%`
                                        }}
                                    />
                                </CircularProgressbarWithChildren>
                            </div>
                            <div style={{textAlign: "center"}} className={"container-fluid"}>
                                {this.getProgressInfo()}
                            </div>
                        </div>
                    );
                case TYPE.MESSAGE:
                    document.addEventListener('keydown', this.closeConfirmation);
                    Utils.$('button').blur();
                    Utils.$('input').blur();
                    return (
                        <div style={{height: "100%"}} id={'message-modal'}>
                            <div style={{height: 38, textAlign: "center", marginBottom: 2}} className={"row"}>
                                <div className={"col-12"}>
                                    <i style={{color: "white"}} className={this.getFasClass()} aria-hidden={"true"} />
                                </div>
                            </div>
                            <div style={{
                                maxHeight: 121,
                                overflow: "auto",
                                borderRadius: 5,
                                background: '#3F4344'
                            }} className={"row"}>
                                <div className={"col-12"}>
                                    <div style={{textAlign: "center"}}>
                                        <label style={{color: '#b5b5b5'}}>{this.state.spinner.message}</label>
                                    </div>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div style={{padding: 0}} className={"col-12"}>
                                    <div style={{float: "right"}}>
                                        <button onClick={this.onClose.bind(this)}
                                                id={'ok-btn'}
                                                tabIndex={1}
                                                style={{
                                                    borderRadius: 5,
                                                    width: 60,
                                                    height: 34,
                                                    margin: 5,
                                                    marginRight: 0
                                                }}
                                                className={"btn btn-new-design"}>Ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                default:
                    return null
            }
        }
        return null;
    };

    closeConfirmation = (e) => {
        if (e.keyCode === 13) {
            if (TYPE.MESSAGE === this.state.spinner.type) {
                this.onClose();
            }
            document.removeEventListener('keydown', this.closeConfirmation);
        }
    };

    getBackgroundColor = (): string => {
        if (this.state.spinner) {
            switch (this.state.spinner.status) {
                case STATUS.ERROR:
                    return "#3f4344";
                case STATUS.WARNING:
                    return "#3f4344";
                case STATUS.SUCCESS:
                    return "#3f4344";
            }
        }
        return "transparent";
    };

    getBorderColor = (): string => {
        if (this.state.spinner) {
            switch (this.state.spinner.status) {
                case STATUS.ERROR:
                    return "#BD362F";
                case STATUS.WARNING:
                    return "#F89406";
                case STATUS.SUCCESS:
                    return "#51A351";
            }
        }
        return "transparent";
    }

    render() {
        return (
            <Modal
                center
                focusTrapped={true}
                open={(this.props.isOpen && (this.state.spinner && this.state.spinner.type !== TYPE.NONE) as boolean)}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 400,
                        boxShadow: "none",
                        paddingBottom: 0,
                        borderRadius: 5,
                        background: this.getBackgroundColor(),
                        border: `7px solid ${this.getBorderColor()}`
                    }
                }}
                closeOnEsc={false}
                closeOnOverlayClick={false}
                onClose={this.onClose.bind(this)}
            >
                <div className={"container-fluid"}>
                    {this.getContent()}
                </div>
            </Modal>
        )
    }


    static async all<T>(values: (T | Promise<T>)[], spinnerConfig: ISpinnerConfig): Promise<T[]> {
        store.dispatch(setSpinner(spinnerConfig.key));
        const spinner = store.getState().actionSpinner.loadingMap.get(spinnerConfig.key) as ISpinner;
        if (spinnerConfig.excludeSpinner) spinner.type = TYPE.NONE;
        try {
            const response = await Axios.all(values);
            if (!!spinnerConfig.showOnSuccess) {
                spinner.type = TYPE.MESSAGE;
                spinner.status = STATUS.SUCCESS;
                spinner.message = spinnerConfig.onSuccessMessage || "Action finished successfully.";
                store.dispatch(updateSpinner(spinnerConfig.key, spinner));
            } else {
                setTimeout(() => {
                    store.dispatch(deleteSpinner(spinnerConfig.key));
                }, 10)
            }
            return response
        } catch (e) {
            errorHandler(spinnerConfig, spinner, e);
        }
    };

    static async post<T = any, R = AxiosResponse<T>>(url: string, data: any, config: AxiosRequestConfig, spinnerConfig: ISpinnerConfig, useBaseURL?: boolean): Promise<any> {
        store.dispatch(setSpinner(spinnerConfig.key));
        const spinner = store.getState().actionSpinner.loadingMap.get(spinnerConfig.key) as ISpinner;
        if (spinnerConfig.excludeSpinner) spinner.type = TYPE.NONE;
        try {
            let response;
            if ((useBaseURL !== undefined || useBaseURL !== null) && useBaseURL === false) {
                response = await Axios.instanceV2.post(url, data, config);
            } else {
                response = await Axios.instance.post(url, data, config);
            }
            if (!!spinnerConfig.showOnSuccess) {
                spinner.type = TYPE.MESSAGE;
                spinner.status = STATUS.SUCCESS;
                spinner.message = spinnerConfig.onSuccessMessage || response.data.message || "Action finished successfully.";
                store.dispatch(updateSpinner(spinnerConfig.key, spinner));
            } else {
                setTimeout(() => {
                    store.dispatch(deleteSpinner(spinnerConfig.key));
                }, 10)
            }
            return response;
        } catch (e) {
            errorHandler(spinnerConfig, spinner, e);
        }
    }

    static async postPurePath<T = any, R = AxiosResponse<T>>(url: string, data: any, config: AxiosRequestConfig, spinnerConfig: ISpinnerConfig): Promise<any> {
        store.dispatch(setSpinner(spinnerConfig.key));
        const spinner = store.getState().actionSpinner.loadingMap.get(spinnerConfig.key) as ISpinner;
        if (spinnerConfig.excludeSpinner) spinner.type = TYPE.NONE;
        try {
            const response = await Axios.instance.post(url, data, config);
            if (!!spinnerConfig.showOnSuccess) {
                spinner.type = TYPE.MESSAGE;
                spinner.status = STATUS.SUCCESS;
                spinner.message = spinnerConfig.onSuccessMessage || response.data.message || "Action finished successfully.";
                store.dispatch(updateSpinner(spinnerConfig.key, spinner));
            } else {
                setTimeout(() => {
                    store.dispatch(deleteSpinner(spinnerConfig.key));
                }, 10)
            }
            return response;
        } catch (e) {
            if (spinnerConfig.showOnError) {
                spinner.type = TYPE.MESSAGE;
                spinner.status = STATUS.ERROR;
                if (e.request && e.request.response) {
                    try {
                        spinner.message = spinnerConfig.onErrorMessage || JSON.parse(e.request.response).message
                            || JSON.parse(e.request.response).error_description || "Something went wrong.";
                    } catch (error) {
                        spinner.message = e.message || "Something went wrong.";
                    }
                } else {
                    spinner.message = e.toString();
                }
                store.dispatch(updateSpinner(spinnerConfig.key, spinner));
            } else {
                setTimeout(() => {
                    store.dispatch(deleteSpinner(spinnerConfig.key));
                }, 10)
            }
            throw e;
        }
    }

    static async get<T = any, R = AxiosResponse<T>>(url: string, config: AxiosRequestConfig, spinnerConfig: ISpinnerConfig, useBaseURL?: boolean): Promise<any> {
        store.dispatch(setSpinner(spinnerConfig.key));
        const spinner = store.getState().actionSpinner.loadingMap.get(spinnerConfig.key) as ISpinner;
        if (spinnerConfig.excludeSpinner) spinner.type = TYPE.NONE;
        try {
            let response;
            if (spinnerConfig.useNewAxiosInstance) {
                response = await Axios.create({
                    baseURL: `${process.env.APP_BASE_URL}/`,
                    withCredentials: true,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Time-Zone': "US"
                    }
                }).get(url);
            } else {
                if ((useBaseURL !== undefined || useBaseURL !== null) && useBaseURL === false) {
                    response = await Axios.instanceV2.get(url, config);
                } else {
                    response = await Axios.instance.get(url, config);
                }
            }
            if (!!spinnerConfig.showOnSuccess) {
                spinner.type = TYPE.MESSAGE;
                spinner.status = STATUS.SUCCESS;
                spinner.message = spinnerConfig.onSuccessMessage || response.data.message || "Action finished successfully.";
                store.dispatch(updateSpinner(spinnerConfig.key, spinner));
            } else {
                setTimeout(() => {
                    store.dispatch(deleteSpinner(spinnerConfig.key));
                }, 10)
            }
            return response;
        } catch (e) {
            errorHandler(spinnerConfig, spinner, e);
        }
    }

    static async delete<T = any, R = AxiosResponse<T>>(url: string, config: AxiosRequestConfig, spinnerConfig: ISpinnerConfig, useBaseURL?: boolean): Promise<any> {
        store.dispatch(setSpinner(spinnerConfig.key));
        const spinner = store.getState().actionSpinner.loadingMap.get(spinnerConfig.key) as ISpinner;
        if (spinnerConfig.excludeSpinner) spinner.type = TYPE.NONE;
        try {
            let response;
            if (spinnerConfig.useNewAxiosInstance) {
                response = await Axios.create({
                    baseURL: `${process.env.APP_BASE_URL}/`,
                    withCredentials: true,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Time-Zone': "US"
                    }
                }).delete(url);
            } else {
                if ((useBaseURL !== undefined || useBaseURL !== null) && useBaseURL === false) {
                    response = await Axios.instanceV2.delete(url, config);
                } else {
                    response = await Axios.instance.delete(url, config);
                }
            }
            if (!!spinnerConfig.showOnSuccess) {
                spinner.type = TYPE.MESSAGE;
                spinner.status = STATUS.SUCCESS;
                spinner.message = spinnerConfig.onSuccessMessage || response.data.message || "Action finished successfully.";
                store.dispatch(updateSpinner(spinnerConfig.key, spinner));
            } else {
                setTimeout(() => {
                    store.dispatch(deleteSpinner(spinnerConfig.key));
                }, 10)
            }
            return response;
        } catch (e) {
            errorHandler(spinnerConfig, spinner, e);
        }
    }

    static async put<T = any, R = AxiosResponse<T>>(url: string, data: any, config: AxiosRequestConfig, spinnerConfig: ISpinnerConfig, useBaseURL?: boolean): Promise<any> {
        store.dispatch(setSpinner(spinnerConfig.key));
        const spinner = store.getState().actionSpinner.loadingMap.get(spinnerConfig.key) as ISpinner;
        if (spinnerConfig.excludeSpinner) spinner.type = TYPE.NONE;
        try {
            let response;
            if ((useBaseURL !== undefined || useBaseURL !== null) && useBaseURL === false) {
                response = await Axios.instanceV2.put(url, data, config);
            } else {
                response = await Axios.instance.put(url, data, config);
            }
            if (!!spinnerConfig.showOnSuccess) {
                spinner.type = TYPE.MESSAGE;
                spinner.status = STATUS.SUCCESS;
                spinner.message = spinnerConfig.onSuccessMessage || response.data.message || "Action finished successfully.";
                store.dispatch(updateSpinner(spinnerConfig.key, spinner));
            } else {
                setTimeout(() => {
                    store.dispatch(deleteSpinner(spinnerConfig.key));
                }, 10)
            }
            return response;
        } catch (e) {
            errorHandler(spinnerConfig, spinner, e);
        }
    }
}

const errorHandler = (spinnerConfig, spinner, e) => {
    if (spinnerConfig.showOnError) {
        spinner.type = TYPE.MESSAGE;
        spinner.status = STATUS.ERROR;
        if (e.request && e.request.response) {
            try {
                spinner.message = spinnerConfig.onErrorMessage || JSON.parse(e.request.response).message || "Something went wrong.";
            } catch (error) {
                spinner.message = e.message || "Something went wrong.";
            }
        } else {
            spinner.message = e.toString();
        }
        store.dispatch(updateSpinner(spinnerConfig.key, spinner));
    } else {
        setTimeout(() => {
            store.dispatch(deleteSpinner(spinnerConfig.key));
        }, 10)
    }
    throw e;
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        isOpen: state.actionSpinner.isOpen,
        loadingMap: state.actionSpinner.loadingMap,
        loadingMapHash: hash(state.actionSpinner.loadingMap),
    }
};

const mapDispatchToProps = (dispatch: any) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionSpinner)



// WEBPACK FOOTER //
// ./app/components/common/ActionSpinner.tsx